export const INVESTOR = {
  nav: 'investor-nav',
  navLink: (id) => `nav-link-${id}`,
  navContact: 'nav-contact-cta',
  hero: 'hero-section',
  heroName: 'hero-name',
  about: 'about-section',
  thesis: 'thesis-section',
  thesisChapter: (n) => `thesis-chapter-${n}`,
  portfolio: 'portfolio-section',
  portfolioItem: (id) => `portfolio-item-${id}`,
  contact: 'contact-section',
  contactName: 'contact-name-input',
  contactEmail: 'contact-email-input',
  contactCompany: 'contact-company-input',
  contactMessage: 'contact-message-input',
  contactSubmit: 'contact-submit-button',
  footer: 'investor-footer',
};
